import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import YouTube from "react-youtube";
import ReactPlayer from "react-player/youtube";
import thumbail from "../../images/logo/logo_aqua.svg";
const ServiceHomeSection = () => {
  const opts = {
    playerVars: {
      autoplay: 0,
      controls: 1,
      modestbranding: 1,
      rel: 0,

      image: "https://picsum.photos/id/2/5000/3333",
    },
  };
  return (
    <>
      <div className="container mx-auto mb-20 mt-44 md:px-40 sm:px-40 md:mb-10">
        <div className="flex flex-col p-4 xl:flex-row space-x-7">
          <div className="">
            <div className="flex justify-center rounded-3xl">
              <ReactPlayer
                playing={true}
                url="https://www.youtube.com/watch?v=yp9F5W9jVHA"
                light={<img src={thumbail} alt="Thumbnail" className=" w-80" />}
              />
            </div>
          </div>
          <div className="flex flex-col   items-start gap-[23px]  mt-10 md:mt-0">
            <p className="relative w-full xl:w-[384px] text-justify   mt-[-0.70px] [font-family:'Inter',Helvetica] font-semibold text-[#333333] text-[30px] tracking-[0] leading-[40px]">
              AQUAVESC, le service public de l&#39;eau
            </p>
            <div className="flex  w-full text-justify items-start gap-[91px] relative mb-[-0.14px]">
              <p className="">
                Aquavesc est un établissement territorial en charge de la
                production, du traitement et de la distribution d’eau potable
                pour 32 communes des départements des Yvelines et des
                Hauts-de-Seine, qui en maître d’ouvrage délègue cette compétence
                à SEOP (SUEZ) via une DSP valable jusqu’en décembre 2026. Avec
                11 forages de captation de l’eau brute, une usine de production
                d’eau et plus de 1 400 km de canalisations, AQUAVESC distribue
                chaque année plus de 25 millions de m3 d’eau potable auprès de
                520 000 habitants, avec un budget moyen annuel de 5 M€ et un
                budget d’investissement de 15 M€ .
              </p>
            </div>
            <Button className="w-1/3">
              {" "}
              <Link to="/a-propos-de-nous">Voir plus</Link>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceHomeSection;
